module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "bodyTypeTitleIcon.a3f075d3.svg";